export default __webpack_public_path__ + "static/media/as we fade i.160385e9.jpg";